export default "__VITE_ASSET__DFrox5E9__"